export default __webpack_public_path__ + "static/media/livro4.0074ee6e.png";